module.exports = __webpack_public_path__ + "img/mobile-alert.a3605eb1.png";